import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AdminMobileTopbar from "./AdminMobileTopbar";
import UploadFileModal from "../../common/UploadFileModal";

/**
 * Mobile "Nueva base" screen - just a full-screen host for the existing
 * UploadFileModal (CSV parsing/upload logic untouched, reused as-is).
 * Closing it goes back to the dashboard, matching desktop's flow where
 * this same modal is triggered from the sidebar over the dashboard.
 */
const MobileNewBase = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-screen bg-secondaryBg">
      <AdminMobileTopbar title={t("dashboard.uploadContact.uploadFile")} />
      <UploadFileModal open={true} onClose={() => navigate("/dashboard")} />
    </div>
  );
};

export default MobileNewBase;
